<div class="notification-card">
  <div ubi-curve-header class="notification-card__header">
    <span class="notification-card__header-text"> {{ 'user_notifications.header' | translate }} </span>
  </div>
  <artemis-popover *ngIf="showPopover">
    <ng-container *ngFor="let section of ('user_notifications.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="notification-card__content-container">
    <div class="notification-card__dropdown" *ngIf="_allDomains.length > 0">
      <mat-form-field class="custom-mat-form-field">
        <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
        <mat-select [ngModel]="selectedDomain?.id" (selectionChange)="onDomainFilterHandler($event)">
          <mat-option *ngFor="let domain of _allDomains" [value]="domain?.id">{{domain.domainName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="user-list-card__tool-bar-container">
      <div class="user-list-card__tool-bar">
        <mat-form-field class="custom-mat-form-field user-list-card__search-field">
          <input matInput [formControl]="searchFormControl" placeholder="{{ 'general.search.label.search_by_name' | translate }}" autocomplete="off" [readonly]="(loading$ | async)">
          <img matSuffix class="themified-white-icon user-list-card__search-icon" src="/assets/icons/magnifying-glass-icon.png">
        </mat-form-field>
      </div>
      <div class="filter-tool-bar">
        <mat-form-field class="custom-mat-form-field filter-tool-bar__form-field">
          <mat-label> {{ 'general.search.label.filter_by' | translate }} </mat-label>
          <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
          <mat-select multiple panelClass="custom-mat-optgroup" (selectionChange)="onSelectionChangeHandler($event)">
            <mat-optgroup [label]="filter.title">
              <mat-option *ngFor="let filterItem of filter.items" [value]="filterItem">
                {{filterItem.key}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="notification-table-and-paginator-container">
      <artemis-loading-spinner *ngIf="loading$ | async"></artemis-loading-spinner>
      <div class="notification-table-container">
        <table mat-table class="custom-mat-table notification-table" [dataSource]="dataSource">
          <ng-container matColumnDef="checked">
            <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.notify' | translate }} </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox class="custom-mat-checkbox" [checked]="element.checked" (change)="updateAllNotifications(element, $event)"></mat-checkbox>
            </td>
          </ng-container>
          <!-- Position Column -->
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef class="notification-table__header_user"> {{ 'general.table.label.user' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="uppercase-text"> {{element.name}} ({{element.email}})</td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="l1">
            <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.l1' | translate }} </th>
            <td mat-cell *matCellDef="let element">
              <img class="notification-table__icon" [src]="element.l1 ? '/assets/icons/active-customer-icon.png' : '/assets/icons/inactive-cutomer-icon.png'">
            </td>
          </ng-container>
          <ng-container matColumnDef="l2">
            <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.l2' | translate }} </th>
            <td mat-cell *matCellDef="let element">
              <img class="notification-table__icon" [src]="element.l2 ? '/assets/icons/active-customer-icon.png' : '/assets/icons/inactive-cutomer-icon.png'">
            </td>
          </ng-container>
          <ng-container matColumnDef="l3">
            <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.l3' | translate }} </th>
            <td mat-cell *matCellDef="let element">
              <img class="notification-table__icon" [src]="element.l3 ? '/assets/icons/active-customer-icon.png' : '/assets/icons/inactive-cutomer-icon.png'">
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="notification-table-empty-hint" *ngIf="paginator.length === 0">
          {{ 'user_notifications.message' | translate }}
        </div>
      </div>
      <mat-paginator class="custom-mat-paginator" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>

    <!-- For button display in manual onboarding page, batch upload page and account settings page -->
    <div class="action-buttons__container" [class.action-buttons__container_flex]="showResetButton" *ngIf="showActionButtons">
      <button mat-button class="btn btn_accent-gradient-rounded clear-users-button" ubi-round-button
              (click)="clearDefaultUsers()" *ngIf="showResetButton">
        {{ 'user_notifications.button.clear_default_users' | translate }}
      </button>
      <button mat-button class="btn btn_rounded save-preferences-btn" ubi-round-button (click)="saveSelectedUsers()">
        {{ 'user_notifications.button.save_selected_as_default' | translate }}
      </button>
    </div>
    <!-- End button display -->

    <!-- For button display in access control page -->
    <div class="action-buttons__container" *ngIf="!showActionButtons">
      <button mat-button class="btn btn_accent-gradient-rounded submit-notified-user-button" ubi-round-button
              (click)="submitSelected()">
        SUBMIT
      </button>
    </div>
    <!-- End button display -->
  </div>
</div>
